var _rect, _text, _rect2, _circle, _text2, _text3, _rect3, _circle2, _text4, _text5, _rect4, _circle3, _text6, _text7, _rect5, _circle4, _text8, _text9, _path, _rect6, _circle5, _text0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentWhatWeBuildCapabilityModelMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 610,
    viewBox: "0 0 360 610",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Custom system capability model") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 358,
    height: 608,
    rx: 27,
    fill: "#020B1B",
    stroke: "#2B5A85"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 42,
    fill: "#74BDFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 0
  }, "WHAT THE SYSTEM CAN BECOME"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 68,
    width: 312,
    height: 92,
    rx: 16,
    fill: "#0A1C34",
    fillOpacity: 1,
    stroke: "#294766"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 93,
    r: 7,
    fill: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 98,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Operational platforms")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 128,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 0
  }, "End-to-end systems for managing complex"), /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 16
  }, "work across teams and locations."))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 174,
    width: 312,
    height: 92,
    rx: 16,
    fill: "#0A1C34",
    fillOpacity: 1,
    stroke: "#294766"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 199,
    r: 7,
    fill: "#FF2775"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 204,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Custom CRMs")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 234,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 0
  }, "Purpose-built relationships, cases,"), /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 16
  }, "opportunities and service workflows."))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 280,
    width: 312,
    height: 92,
    rx: 16,
    fill: "#0A1C34",
    fillOpacity: 1,
    stroke: "#294766"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 305,
    r: 7,
    fill: "#30D6A1"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 310,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Intelligent workflows")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 340,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 0
  }, "Evidence capture, validation, routing,"), /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 16
  }, "alerts and automated action."))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 386,
    width: 312,
    height: 92,
    rx: 16,
    fill: "#0A1C34",
    fillOpacity: 1,
    stroke: "#294766"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 411,
    r: 7,
    fill: "#F4B63D"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 416,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Decision and reporting systems")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 446,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 0
  }, "Live visibility, analytical models and"), /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 16
  }, "management control."))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 478v32",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 511,
    width: 312,
    height: 71,
    rx: 15,
    fill: "#10243E",
    stroke: "#2B5A85"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 546,
    r: 6,
    fill: "#30D6A1"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 539,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 66,
    dy: 0
  }, "ONE CONNECTED OPERATING MODEL"), /*#__PURE__*/React.createElement("tspan", {
    x: 66,
    dy: 18
  }, "The form follows the operational need."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentWhatWeBuildCapabilityModelMobile);
export default __webpack_public_path__ + "static/media/custom-development-what-we-build-capability-model-mobile.5b205c81bc413c8283c19197b79ed51d.svg";
export { ForwardRef as ReactComponent };